// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"A7-z"};